// Description for invitation code
export const INVITE_CODE_MESSAGE: string = `This code is unique to your business. The invite code will not be active until you have a minimum on One department in your department list.
To create your list click on the department's tab and then “Add a Department”`;
